import {Component} from '@angular/core';
import {ToastrService} from 'ngx-toastr';

import {BulkSettingsService} from 'OpsCenter/ops-support/settings/bulk-settings.service';
import {BulkSettingsUpdate} from "OpsCenter/ops-support/settings/bulk-settings-update";

@Component({
  selector: 'app-merchant-closure',
  template: require('./bulk-settings.component.html'),
  styles: [require('./bulk-settings.component.less')],
})
export class BulkSettingsComponent {
  public merchantIds = '';
  public maxReservationSize = 0;

  constructor(private bulkSettingsService: BulkSettingsService, private notificationService: ToastrService) {
  }

  updateLeadTimes() {
    if (this.confirmAction()) {
      return;
    }
    this.bulkSettingsService
      .updateLeadTimes(this.convertToRequestBody(this.merchantIds))
      .subscribe(this.handleUpdateSuccess(), this.handleUpdateFailure());
  }

  updateCutOffTimes() {
    if (this.confirmAction()) {
      return;
    }
    this.bulkSettingsService
      .updateCutoffTimes(this.convertToRequestBody(this.merchantIds))
      .subscribe(this.handleUpdateSuccess(), this.handleUpdateFailure());
  }

  updateMaxReservationSize() {
    if (this.maxReservationSize < 0) {
      this.notificationService.error("Please select a value bigger or equal to 0");
      return;
    }

    if (this.confirmAction()) {
      return;
    }
    this.bulkSettingsService
      .updateMaxReservationSize(this.convertToRequestBodyWithValue(this.merchantIds, this.maxReservationSize))
      .subscribe(this.handleUpdateSuccess(), this.handleUpdateFailure());
  }

  updateAutomaticConfirmation() {
    if (this.confirmAction()) {
      return;
    }
    this.bulkSettingsService
      .updateAutomaticConfirmation(this.convertToRequestBody(this.merchantIds))
      .subscribe(this.handleUpdateSuccess(), this.handleUpdateFailure());
  }

  updateCoverLimits() {
    if (this.confirmAction()) {
      return;
    }
    this.bulkSettingsService
      .updateCoverLimits(this.convertToRequestBody(this.merchantIds))
      .subscribe(this.handleUpdateSuccess(), this.handleUpdateFailure());
  }

  private convertToRequestBody(stringIds: string = ''): BulkSettingsUpdate {
    if (stringIds.length === 0) {
      return {merchantIds: []}
    }
    return {merchantIds: this.convertToNumberArray(stringIds)};
  }

  private convertToRequestBodyWithValue(stringIds: string = '', value = null): BulkSettingsUpdate {
    if (stringIds.length === 0) {
      return {merchantIds: [], value}
    }
    return {merchantIds: this.convertToNumberArray(stringIds), value};
  }

  private convertToNumberArray(stringIds: string) {
    return stringIds.split(',').map(s => s.trim()).map(s => parseInt(s, 10));
  }

  private handleUpdateSuccess() {
    return () => {
      this.notificationService.success('Settings updated')
    };
  }

  private handleUpdateFailure() {
    return () => {
      this.notificationService.error('Failed to update settings')
    };
  }

  private confirmAction() {
    return !window.confirm('Please confirm update operation');
  }
}



// WEBPACK FOOTER //
// ./src/app/ops-support/settings/bulk-settings.component.ts